module.exports = __webpack_public_path__ + "static/img/evocomWeChat.aa60d908.jpg";